define('view/controller/gdpr-report/GdprReportControlPanelView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     *
     *
     * @class GdprReportControlPanelView
     */
    return LayoutView.extend({

        template: '#gdpr_report_control_panel_view',

        modelEvents: {
            'change': 'render'
        },

        ui : {
            printBtn : '#sb_gdpr_report_print',
            jsonBtn : '#sb_gdpr_report_json',
            logoutBtn : '#sb_gdpr_report_logout',
        },

        triggers : {
            'click @ui.printBtn' : 'print_report',
            'click @ui.jsonBtn' : 'json_report',
            'click @ui.logoutBtn' : 'logout_report',
        },

        initialize: function (options) {

        },

        onRender: function () {
            //console.log(this.model.attributes);
        },

        serializeData: function () {
            var result = Marionette.ItemView.prototype.serializeData.apply(this);

            return result;
        },

    });

});
